<template>
    <div class="sidebar sidebar--sm">
        <div class="sidebar__tabs">
            <nuxt-link to="/dostavka/" class="tab">
                <span>{{ $t("delivery") }}</span>
            </nuxt-link>
            <nuxt-link to="/vozvrat/" class="tab">
                <span>{{ $t("return") }}</span>
            </nuxt-link>
            <nuxt-link to="/faq/" class="tab">
                <span>{{ $t("faq") }}</span>
            </nuxt-link>
            <div class="tab" :class="changedDoc ? 'no_border' : ''" @click="changedDoc = !changedDoc">
                <div class="tab__title" :class="changedDoc ? 'is_open' : ''">{{ $t("docs") }}</div>
            </div>
        </div>
        <div class="documents" v-show="changedDoc">
            <div class="documents__list">
                <nuxt-link :to="`/dokumenty/${slug}/`" v-for="(title, slug) in docs" :key="slug">
                    <span>{{ title }}</span>
                </nuxt-link>
            </div>
        </div>
        <div class="sidebar__footer text_11">
            <PPSCallBack />
        </div>
    </div>
</template>

<script>
import PPSCallBack from "@/components/PPSCallBack.vue";
import { mapGetters } from "vuex";
export default {
    name: "Pomosh-klientam",
    layout: "help",
    components: {
        PPSCallBack,
    },
    head() {
        return {
            title: this.$i18n.t("customer_help") + " | " + this.$i18n.t("pps_title"),
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: this.$i18n.t("text_customer_help"),
                },
                {
                    hid: "og:description",
                    property: "og:description",
                    content: this.$i18n.t("text_customer_help"),
                },
            ],
        };
    },
    async asyncData({ $axios }) {
        const docs = await $axios.get("/api/documents");

        const data = {
            docs: docs.data,
        };
        return data;
    },
    data() {
        return {
            activeModal: null,
            activeInModal: "courier",
            city: "",
            currentShop: null,
            changedDoc: false,
        };
    },
    computed: {
        ...mapGetters({
            langust: "globalvars/getLang",
        }),
        crumbs() {
            return [{ name: this.$i18n.t("customer_help") }];
        },
    },
    watch: {
        async langust() {
            await this.$nuxt.refresh();
            this.$store.commit("crumbs/change", this.crumbs);
        },
    },
    methods: {
        showModal(name) {
            this.activeModal = name;
        },
        showInModal(name) {
            this.activeInModal = name;
        },
        openBlock(nameCity) {
            this.city = nameCity;
        },
    },
    mounted() {
        this.$store.commit("crumbs/change", this.crumbs);
    },
};
</script>
<style lang="less" scoped>
.documents__list {
    a + a {
        margin-top: 8px;
    }
}
</style>
